import React, { useEffect, useState } from 'react';
import { Button, Collapsible } from '@chakra-ui/react';
import { Context } from '../../App';
import { useMutation } from 'react-query';
import Card from '../../base-components/Card';
import { updateCompanySettings } from '../../api/company-setting-controller';
import CompanySetting from '../../model/product copy';
import Input from '../../base-components/Input';
import _ from 'lodash';


const CompanySettings = () => {
    const { translations, companySettings } = React.useContext(Context);
    const [currentCompanySettings, setCurrentCompanySettings] = useState<CompanySetting | null>(companySettings?.data || null);
    const [isDirty, setIsDirty] = useState(false);

    const { mutate: doUpdateCompanySettings } = useMutation(updateCompanySettings);

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentCompanySettings(prevState => {
            if (prevState) {
                return { ...prevState, [e.target.name]: e.target.value };
            }

            return prevState;
        });
    };

    useEffect(() => {
        if (companySettings?.data) {

            setCurrentCompanySettings(companySettings.data);
        }
    }, [companySettings?.data]);

    useEffect(() => {
        setIsDirty(!_.isEqual(currentCompanySettings, companySettings?.data));
    }, [currentCompanySettings, companySettings]);

    const updateFromCurrentCompanySettings = () => {
        if (currentCompanySettings) {
            doUpdateCompanySettings(currentCompanySettings);
        }
    };

    return (
        <Card title={translations.systemSettings.companySettings.title} description={translations.systemSettings.companySettings.description}>
            {`${currentCompanySettings?.id} - ${currentCompanySettings?.name}`}
            <Input disabled title={translations.model.companySettings.id} name="id" defaultValue={currentCompanySettings?.id} />
            <Input title={translations.model.companySettings.name} name="name" defaultValue={currentCompanySettings?.name} onChange={handleInput} />
            <Input title={translations.model.companySettings.mapboxToken} name="mapboxToken" defaultValue={currentCompanySettings?.mapboxToken} type={"text"} onChange={handleInput} />
            <Input title={translations.model.companySettings.geocodingToken} name="geocodingToken" defaultValue={currentCompanySettings?.geocodingToken} type={"text"} onChange={handleInput} />
            <Collapsible.Root open={isDirty}>
                <Collapsible.Content>
                    <Button onClick={updateFromCurrentCompanySettings}>{translations.systemSettings.companySettings.save}</Button>
                </Collapsible.Content>
            </Collapsible.Root>
        </Card>
    );
}

export default CompanySettings;